import { useMutation } from '@tanstack/react-query'
import { sendTransactionExportToEmailAllWallets } from 'services/TransactionService'

export const useSendAllTransactionsToEmailMutation = () =>
  useMutation({ mutationFn: sendTransactionExportToEmailAllWallets })
